import { CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "../../shared/axios/axiosProxy.js";
import i18n from "../../utils/i18n.js";

// This page waits after Hubspot redirect until Zapier creates the AspRequest,
// then automatically redirects to the Stripe payment page
const HubspotIntermediateRedirect = () => {
  const { search } = useLocation();
  const [error, setError] = useState("");

  useEffect(() => {
    // Polling: wait until Zapier creates the AspRequest with priceId
    const pageLoadTs = Date.now();
    const pollInterval = setInterval(async () => {
      try {
        // Fetch only the latest request that has a priceId and was created after page load
        const { data } = await axios.get(
          `/api/aspreq/latest?requirePriceId=true&after=${pageLoadTs}`,
        );
        if (data.reqId) {
          clearInterval(pollInterval);
          const backendBase = process.env.REACT_APP_BACKEND_API || "";
          window.location.href = `${backendBase}/api/hubspot-redirect/submission?reqId=${data.reqId}`;
        }
      } catch (err) {
        console.error("Polling error:", err);
      }
    }, 1000); // Poll every 1 second

    // Stop polling after 45 seconds
    setTimeout(() => {
      clearInterval(pollInterval);
      setError("Request timeout. Please try again.");
    }, 45000);

    return () => clearInterval(pollInterval);
  }, [search]);

  if (error)
    return (
      <div
        style={{
          color: "red",
          padding: "20px",
          textAlign: "center",
          marginTop: "40px",
          fontSize: "18px",
        }}
      >
        {error}
      </div>
    );
  return (
    <div
      style={{
        padding: "20px",
        textAlign: "center",
        marginTop: "60px",
        fontSize: "18px",
      }}
    >
      <CircularProgress
        size={50}
        thickness={4}
        style={{ marginBottom: "20px" }}
      />
      <div
        style={{ fontSize: "20px", fontWeight: "600", marginBottom: "10px" }}
      >
        {i18n.t("general.stripepaymentloading")}
      </div>
      <div style={{ fontSize: "16px", color: "#666" }}>
        {i18n.t("general.stripepaymentredirect")}
      </div>
    </div>
  );
};

export default HubspotIntermediateRedirect;
